import { render, staticRenderFns } from "./_view-support-ticket.vue?vue&type=template&id=8fca996a"
import script from "./_view-support-ticket.vue?vue&type=script&lang=js"
export * from "./_view-support-ticket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports